import React from 'react';
import PropTypes from 'prop-types';
import Page from 'Common/Layout/Page';
import classNames from './navigation.module.css';
import { makeStyles } from 'utils';

const styles = makeStyles(classNames);

function MenuPage({ title, children }) {
    return (
        <Page title={title}>
            <section className={styles('menu-page')}>
                {React.Children.map(children, child => (
                    <div className={styles('menu-page__column')}>
                        {child}
                    </div>
                ))}    
            </section>
        </Page>
    );
}

Page.propTypes = {
    title: PropTypes.string.isRequired
};

export default MenuPage;